import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AccessoryService } from 'app/rest/accessory.service';
import { DivisionService } from 'app/rest/division.service';
import { FineService } from 'app/rest/fine.service';
import { FleetService } from 'app/rest/fleet.service';
import { SubdelegationService } from 'app/rest/subdelegation.service';
import { SubdivisionService } from 'app/rest/subdivision.service';
import { VehicleService } from 'app/rest/vehicle.service';
import { VehicleUsageService } from 'app/rest/vehicleUsage.service';
import { VehiclebrandService } from 'app/rest/vehiclebrand.service';
import { VehiclemodelService } from 'app/rest/vehiclemodel.service';
import { VehiclesgroupService } from 'app/rest/vehiclesgroup.service';
import { VehicleversionService } from 'app/rest/vehicleversion.service';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { DocumentationService } from '../../services/documentation.service';
import { DriverService } from '../../services/driver.service';
import { InvVehicleService } from '../../services/invVehicle.service';
import { DelegationService } from '../../services/table-management/delegation.service';
import { FinancingService } from '../../services/table-management/financing.service';
import { InsuranceService } from '../../services/table-management/insurance.service';
import { VehicleAccessoryService } from '../../services/vehicle-accessory.service';
import { VehicleHtcService } from '../../services/vehicle-htc.service';
import { DriverAssignmentsService } from '../../services/driver-assignments.service';
import { VehicleAssignmentsService } from '../../services/vehicle-assignments.service';
import { TaxService } from '../../services/table-management/taxes.service';
import { CardService } from 'app/rest/card.service';
import { NoteService } from '../../services/note.service';
import { MaintenanceexecutionService } from 'app/rest/maintenanceexecution.service';
import { LeaderService } from 'app/rest/leader.service';
import { NoticegroupService } from 'app/rest/noticegroup.service';
import { HtcCardListService } from '../../services/table-management/htc-card-list.service';
import { HtcVehicleStatusListService } from '../../services/table-management/htc-vehicle-status-list.service';
import { HtcVehicleUsageListService } from '../../services/table-management/htc-vehicle-usage-list.service';

@Component({
    selector: 'app-inventory-vehicles',
    templateUrl: './inventory-vehicles.component.html',
    styleUrls: ['./inventory-vehicles.component.css'],
    providers: [
        InvVehicleService,
        DriverService,
        VehicleService,
        VehiclesgroupService,
        VehicleUsageService,
        FleetService,
        VehiclesgroupService,
        ExcelService,
        VehicleHtcService,
        FineService,
        InsuranceService,
        FinancingService,
        DocumentationService,
        VehiclebrandService,
        VehiclemodelService,
        VehicleversionService,
        VehicleAccessoryService,
        AccessoryService,
        DelegationService,
        SubdelegationService,
        DivisionService,
        SubdivisionService,
        DriverAssignmentsService,
        VehicleAssignmentsService,
        TaxService,
        CardService,
        NoteService,
        MaintenanceexecutionService,
        LeaderService,
        NoticegroupService,
        HtcCardListService,
        HtcVehicleStatusListService,
        HtcVehicleUsageListService,
        LeaderService
    ],
    standalone: false
})
export class InventoryVehiclesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
